<template lang="pug">
  div.d-flex.justify-center
    div.overflow-hidden
      div.d-inline-block.mt-n12
        v-img(src="/kk-1.png" alt="佑昇生殖中心，專業生殖醫療與不孕症治療" eager)
</template>

<script>
export default {
  name: "MainTitle",
};
</script>
